import API, { adminHeader } from '../config/axios'

export default {
    getQoSFormVersions: () => {
        return API.get('/QoSFormVersions')
            .then(res => res)
            .catch(err => {
                console.error(err)
                return err
            })
    },
    getAllQoSFormVersions: () => {
        return API.get('/QoSFormVersions/all')
            .then(res => res)
            .catch(err => {
                console.error(err)
                return err
            })
    },
    getQoSFormVersion: (id) => {
        return API.get(`/QoSFormVersions/${id}`)
            .then(res => res)
            .catch(err => {
                console.error(err)
                return err
            })
    }
}
